import { render, staticRenderFns } from "./Zhaop.vue?vue&type=template&id=68e7b5f4&scoped=true&"
import script from "./Zhaop.vue?vue&type=script&lang=js&"
export * from "./Zhaop.vue?vue&type=script&lang=js&"
import style0 from "./Zhaop.vue?vue&type=style&index=0&id=68e7b5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7b5f4",
  null
  
)

export default component.exports